export default {
  sections: {
    state: {
      title: 'Estado',
      fields: {
        pickup_visible: {
          label: 'Recogida visible',
        },
        has_pickup: {
          label: 'Recogida',
        },
      },
    },
    scheduled_orders: {
      title: 'Pedidos programados',
      fields: {
        has_scheduled_orders: {
          label: '¿Permite a sus clientes hacer pedidos con antelación para horarios específicos?',
        },
        min_schedule_ahead_time_pickup: {
          label: 'Tiempo mínimo (minutos) de antelación para programar pedidos de <strong>recogida</strong>',
          placeholder: '30',
        },
        last_order_gap_pickup: {
          label: 'Último momento para pedir <strong>recogida</strong> (minutos antes del cierre)',
          option: '{{value}} min',
        },
      },
    },
    preparation_time_pickup_orders: {
      title: 'Tiempo de preparación para pedidos de recogida',
      fields: {
        average_order_preparation_time_min: {
          label: 'Tiempo de preparación en minutos',
          placeholder: '20',
        },
        average_order_preparation_time_max: {
          label: 'hasta',
          placeholder: 'Opcional',
        },
      },
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    at_least_one_order_method_required:
      'Al menos 1 método de pedido (programado o inmediato) debe estar activado. No se pueden desactivar ambos.',
  },
};
